<script>
import {onMounted, watch} from 'vue';
import {useCartStore} from "@js/store/CartStore.js";
import IconHeart from "@js/components/Icons/IconHeart.vue";
import IconTrash from "@js/components/Icons/IconTrash.vue";
import IconHeartFilled from "@js/components/Icons/IconHeartFilled.vue";
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";
import CartListItem from "@js/components/Sections/Cart/CartListItem.vue";
import CatalogProductItemWide from "@js/components/Sections/Catalog/ProductItem/CatalogProductItemWide.vue";

export default {
    name: 'CartList',
    components: {
        CatalogProductItemWide,
        CartListItem,
        NumberFormatComponent,
        IconHeartFilled,
        IconTrash,
        IconHeart
    },
    setup() {
        const cartStore = useCartStore();

        onMounted(() => {
            cartStore.loadCart()
            cartStore.getCartData()
            cartStore.cart_form_successfully_sent = false
        });

        return {cartStore};
    }
};
</script>

<template>
    <div class="border rounded-2xl overflow-hidden">
        <!-- Шапка -->
        <div class="flex items-center justify-between bg-white border-b px-4 py-3">
            <div class="flex items-center text-lg font-medium">
                <p>Товары</p>
            </div>
            <div v-if="!cartStore.loadings.cart_loading"
                 @click.prevent="cartStore.isCartClearModalVisible = true"
                 class="flex items-center gap-2 text-sm text-gray-600 md:hover:text-red-600 transition leading-tight text-nowrap font-medium cursor-pointer">
                <IconTrash class="w-5 h-5 transition"/>
                Очистить все
            </div>
            <div v-else class="leading-tight text-nowrap font-medium text-sm text-gray-600">
                Обновление корзины...
            </div>
        </div>

        <!-- Skeleton -->
        <div v-if="cartStore.loadings.cart_loading" role="status" v-for="i in 3"
             class="p-4 flex animate-pulse border rounded-lg">
            <div class="grid grid-cols-2 gap-1 w-20 h-20 shrink-0">
                <div class="bg-gray-200 dark:bg-gray-700 rounded"></div>
                <div class="bg-gray-200 dark:bg-gray-700 rounded"></div>
                <div class="bg-gray-200 dark:bg-gray-700 rounded"></div>
                <div class="bg-gray-200 dark:bg-gray-700 rounded"></div>
            </div>
            <div class="flex-1 ml-4 flex flex-col justify-between">
                <div class="space-y-2">
                    <div class="h-5 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
                    <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3"></div>
                    <div class="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
                </div>
                <div class="flex justify-between items-center mt-2">
                    <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3"></div>
                    <div class="flex space-x-2">
                        <div class="h-5 w-5 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
                        <div class="h-5 w-5 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Список товаров -->
        <div v-else class="bg-white">
            <div v-for="product in cartStore.cart_products"
                 class="flex items-start border-b last:border-b-0">
                <CatalogProductItemWide :data="product" :key="product.id" :cart_mode="true"/>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* здесь можно добавить тонкий кастомный CSS, если нужно */
</style>
